import moment from 'moment'

export const Supplier = {
    id: '',
    name: '',
    address: '',
    email: '',
    phone: '',
    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}